export const SET_REGION = 'SET_REGION'
export const UPDATE_FILTER_SEARCH_TERM = 'UPDATE_FILTER_SEARCH_TERM'
export const UPDATE_DIET_TYPE = 'UPDATE_DIET_TYPE'
export const UPDATE_MEAL_TYPE = 'UPDATE_MEAL_TYPE'
export const UPDATE_SORTING = 'UPDATE_SORTING'
export const SHOW_MOBILE_MEALS = 'SHOW_MOBILE_MEALS'
export const SEARCHING = 'SEARCHING'
